import Navbar from "./Navbar";
import Footer from "./Footer";
import "../styles/main.css";

function Layout({ children }) {
    return (
        <>
            <Navbar />
            {children}
            <Footer />
        </>
    );
}

export default Layout;
